import React from 'react';

const Footer = () => {
  return (
  <><div className='wave'></div>
   <div className="footer">  <div className="box footer-gallery">
     
     <img className="logo-img" src="imgs/Mohamed abi.png" alt="" />
   </div>
 <div className="container">
 
   <div className="box">
     <h3>MED ABI</h3>
     <ul className="social">
       <li>
         <a href="https://www.facebook.com/abi.mohamed.10" target="_blank" rel="noopener noreferrer" className="facebook">
           <i className="fab fa-facebook-f"></i>
         </a>
       </li>
       <li>
         <a href="https://twitter.com/mohamed52568273" target="_blank" rel="noopener noreferrer" className="twitter">
           <i className="fab fa-twitter"></i>
         </a>
       </li>
       <li>
         <a href="https://www.youtube.com/@mohamedabi6415/channels" target="_blank" rel="noopener noreferrer" className="youtube">
           <i className="fab fa-youtube"></i>
         </a>
       </li>
       <li>
         <a href="https://github.com/mohamedabi17" target="_blank" rel="noopener noreferrer" className="github">
           <i className="fa fa-github"></i>
         </a>
       </li>
     </ul>
     <p className="text">
       In case You are looking for a software engineer who can solve your efficiency
     </p>
   </div>
   <div className="box">
     <ul className="links">
       <li><a href="https://www.instagram.com/worldweb_solutions/">WORLD WEB SOLUTIONS INSTAGRAM</a></li>
       <li><a href="https://www.facebook.com/WorldWebSoolutions">WORLD WEB SOLUTIONS FACEBOOK</a></li>
       <li><a href="https://www.tiktok.com/@worldwebsolutions">WORLD WEB SOLUTIONS TIKTOK</a></li>
       <li><a href="https://www.youtube.com/channel/UCOAfhjjWrgAWCil4XiZrOpg">WORLD WEB SOLUTIONS YOUTUBE</a></li>

     </ul>
   </div>
   <div className="box">
     <div className="line">
       <i className="fas fa-map-marker-alt fa-fw"></i>
       <div className="info">EL BIAR, Alger</div>
     </div>
     <div className="line">
       <i className="far fa-clock fa-fw"></i>
       <div className="info">Business Hours: Flexible</div>
     </div>
     <div className="line">
       <i className="fas fa-phone-volume fa-fw"></i>
       <div className="info">
         <span>+213774852508</span>
     
       </div>
     </div>
   </div>
   
 </div>
 <p className="copyright">
   Made With 
   {/* <img src='imgs/7401.png_300.png'>
   </img> */}
   <span className="material-symbols-outlined">
favorite
</span>
   By MOHAMED ABI
 </p>
</div>
  
  </>
   
  );
};

export default Footer;
